"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.providersInOrder = providersInOrder;
const conventions_1 = require("../../conventions");
/** Put a claimed root provider first without excluding other dialects. */
function providersInOrder(preferredProvider) {
    if (!preferredProvider)
        return conventions_1.registeredProviders;
    return [
        preferredProvider,
        ...conventions_1.registeredProviders.filter((provider) => provider !== preferredProvider),
    ];
}
